import axios from 'axios';
import { API_HOST } from '../constants/constants';

export const postUniversalLogin = async (loginData, partnerID) => {
  const apiURL = `${API_HOST}/universal_login`;

  try {
    const config = {
      headers: {
        'Cache-Control': 'no-store',
        'Content-Type': 'application/json',
        'x-dqpn-partner-id': partnerID,
        'x-dqpn-platform': 'web',
        Accept: 'application/json',
      },
    };

    const response = await axios.post(apiURL, loginData, config);
    return response;
  } catch (error) {
    console.error('Universal login failed:', error);
    throw error;
  }
};
